import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('card-associated-objects-lib-legacy', {
  library: 'card-associated-objects-lib-legacy'
});
export const SUCCESSFUL_DATA_POLL_TIME = 'successful-data-poll-time';